import { errors } from 'rfc9457';
import { CloudflareError } from '../../httpClient/requestExecutor/cloudflare-error';

const TUNNEL_PATTERN = /tunnel/i;

function detectVaultCloudflareReason(html: string): 'tunnel' | 'worker' | null {
  if (TUNNEL_PATTERN.test(html)) {
    return 'tunnel';
  }
  if (html.includes('exceeded resource limits') || html.includes('Worker')) {
    return 'worker';
  }
  return null;
}

function extractDetail(raw: string, fallback: string): string {
  try {
    const parsed = JSON.parse(raw) as { detail?: string; title?: string };
    return parsed.detail ?? parsed.title ?? fallback;
  } catch {
    return raw || fallback;
  }
}

export async function throwVaultError(res: Response): Promise<never> {
  const contentType = res.headers.get('content-type') ?? '';
  const raw = await res.text().catch(() => '');
  if (contentType.includes('text/html')) {
    const reason = detectVaultCloudflareReason(raw);
    if (reason) {
      throw new CloudflareError({ status: res.status, reason });
    }
  }
  const detail = extractDetail(raw, res.statusText);
  if (res.status === 404) {
    throw errors.client.notFound(detail);
  }
  if (res.status === 400) {
    throw errors.client.badRequest(detail);
  }
  if (res.status === 401) {
    throw errors.client.authentication(detail);
  }
  throw errors.server.internal(detail);
}
